import type { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import type { SelectChangeEvent } from '@mui/material';
import { Grid, MenuItem, Select, Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

export interface GroupedBarHeadersProps {
  colorMap: [string, string][];
  groups: { [value: string]: string };
  groupSelection: string[];
  setGroupSelection: Dispatch<SetStateAction<string[]>>;
  labels?: string[];
}

const GroupedBarHeaders: FC<GroupedBarHeadersProps> = ({
  colorMap,
  groups,
  groupSelection,
  setGroupSelection,
  labels,
}) => {
  const { t } = useTranslation('dashboard');
  const onChange = (i: number) => (e: SelectChangeEvent) =>
    setGroupSelection((prevValue) => {
      const value = [...prevValue];
      value[i] = String(e.target.value);
      return value;
    });

  return (
    <Grid container columnSpacing={{ md: 1.5 }} rowSpacing={{ xs: 1.5, md: 0 }}>
      {groupSelection.map((currentValue, i, source) => (
        <Grid
          item
          xs={12}
          md={12 / (source.length < 2 ? 3 : source.length)}
          key={i}
          sx={{
            display: 'flex',
          }}
        >
          {!!labels && !!labels[i] && (
            <Stack
              direction="column"
              sx={styles.label(colorMap[i % colorMap.length])}
            >
              <Typography component="div">{labels[i]}</Typography>
            </Stack>
          )}
          <Select
            value={groups[currentValue] ? currentValue : ''}
            onChange={onChange(i)}
            role="button"
            displayEmpty
            sx={styles.filterSelect}
            MenuProps={{
              PaperProps: {
                sx: styles.filterPaper,
              },
            }}
          >
            <MenuItem value="">
              <Typography variant="button2">{t('GroupedBar.Empty')}</Typography>
            </MenuItem>
            {Object.entries(groups).map(([value, label]) => (
              <MenuItem value={value} key={value} sx={styles.filterMenuItem}>
                <Typography variant="button2">{label}</Typography>
              </MenuItem>
            ))}
          </Select>
        </Grid>
      ))}
    </Grid>
  );
};

export default GroupedBarHeaders;
